module.exports = __webpack_public_path__ + "img/airgateway-logo-icon-text.35fd48a5.png";